import React from 'react';
import PropTypes from 'prop-types';
import cs from 'classnames';
import {FormattedDate} from 'react-intl';

import {DATESTAMP_MONTH_DATE_HIGHLIGHT} from './config';
import {CalendarTBD} from './icons';

import '../styles/index.scss';

const themeDateStampColor = (theme = {}, cxs) =>
  theme.paletteSecondary &&
  cxs &&
  cxs({
    color: `${theme.paletteSecondary} !important`,
    fill: `${theme.paletteSecondary} !important`,
  });

/**
 *  DateStamp
 * @TODO dateStampYear
 * @TODO dateStamp-small, dateStamp-large
 * @TODO TBD display
 */
export const DateStamp = ({date, theme, className, themeProvider, time, isAllEvents = false}) => {
  const themeDateStampColorClass = themeDateStampColor(theme, themeProvider);
  const timeDisplay = isAllEvents ? (
    <time>
      <span className={cs('DateStamp__MonthDateYear', themeDateStampColorClass)}>
        <span>
          <FormattedDate value={date} month="short" day="numeric" year="numeric" />
        </span>
      </span>
    </time>
  ) : (
    <time>
      <span className={cs('DateStamp__Day', 'DateStamp__Day--highlight', themeDateStampColorClass)}>
        <FormattedDate value={date} weekday="short" />
        <span className="DateStamp__Time">{time}</span>
      </span>
      <span className={cs('DateStamp__MonthDateYear', themeDateStampColorClass)}>
        <span>
          <FormattedDate value={date} month="short" day="numeric" year="numeric" />
        </span>
      </span>
    </time>
  );

  const eventDate = time ? (
    timeDisplay
  ) : theme && theme.dateTimeStampType === DATESTAMP_MONTH_DATE_HIGHLIGHT ? (
    <time>
      <span className={cs('DateStamp__Month', 'DateStamp__Month--highlight', themeDateStampColorClass)}>
        <FormattedDate value={date} month="short" />
      </span>
      <span className={cs('DateStamp__Date', 'DateStamp__Date--highlight', themeDateStampColorClass)}>
        <FormattedDate value={date} day="2-digit" />
      </span>
      <span className="DateStamp__Day--small">
        <FormattedDate value={date} weekday="short" />
      </span>
    </time>
  ) : (
    <time>
      <span className={cs('DateStamp__Day', 'DateStamp__Day--highlight', themeDateStampColorClass)}>
        <FormattedDate value={date} weekday="short" />
      </span>
      <span className="DateStamp__MonthDateYear">
        <span>
          <FormattedDate value={date} month="short" day="numeric" year="numeric" />
        </span>
      </span>
    </time>
  );

  const tbdDate = (
    // TBD Date Section
    <div className="DateStamp__TBD">
      <span className={cs('DateStamp__TBDIcon', themeDateStampColorClass)}>
        <CalendarTBD />
      </span>
    </div>
  );

  return (
    <div className={cs('DateStamp', className)}>
      {date && date instanceof Date && !isNaN(date.getTime()) ? eventDate : tbdDate}
    </div>
  );
};

DateStamp.propTypes = {
  /**
   * The Date Object for the Constructing the Date
   *
   */
  date: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
  theme: PropTypes.object,

  /**
   * Custom class name to add to the outer element
   */
  className: PropTypes.string,

  /**
   * ThemeProvider object for applying the theme.
   *
   */
  themeProvider: PropTypes.func,
  time: PropTypes.string,
  isAllEvents: PropTypes.bool,
};

export default DateStamp;
